var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabases(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.608,
    height: 20.274,
    viewBox: "0 0 21.608 20.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M-321.052-4141.5a2.122,2.122,0,0,1-2.122-2.122,2.122,2.122,0,0,1,2.122-2.122h16.364a2.122,2.122,0,0,1,2.122,2.122,2.122,2.122,0,0,1-2.122,2.122Zm0-7.515a2.122,2.122,0,0,1-2.122-2.122,2.122,2.122,0,0,1,2.122-2.122h16.364a2.122,2.122,0,0,1,2.122,2.122,2.122,2.122,0,0,1-2.122,2.122Zm0-7.515a2.122,2.122,0,0,1-2.122-2.122,2.122,2.122,0,0,1,2.122-2.122h16.364a2.122,2.122,0,0,1,2.122,2.122,2.122,2.122,0,0,1-2.122,2.122Z",
    transform: "translate(323.674 4161.271)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabases);
export default __webpack_public_path__ + "static/media/databases.22b8ab90dfcc2f0839cd86ec33007dbe.svg";
export { ForwardRef as ReactComponent };